/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {KTSVG} from '../../../../helpers'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import { SidebarMenuItem } from './SidebarMenuItem'


const SidebarMenuMain = () => {
  const intl = useIntl()
  

  return (
    <>
      <SidebarMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/art/art002.svg'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      />

      <SidebarMenuItemWithSub
        title='Insights'
        icon='/media/icons/duotune/graphs/gra001.svg'
        fontIcon='bi-graph-up'
      >
        <SidebarMenuItem to='/practitioner-analytics' title='Practitioner Analytics' hasBullet={true} />
        <SidebarMenuItem to='/referrals' title='Referrals' hasBullet={true} />
        <SidebarMenuItem to='/ai-usage' title='AI Usage' hasBullet={true} />
      </SidebarMenuItemWithSub>

      <SidebarMenuItemWithSub
        title='Practitioners & Users'
        icon='/media/icons/duotune/communication/com006.svg'
        fontIcon='bi-people'
      >
        <SidebarMenuItem to='/apps/agents/1' title='Users management' hasBullet={true} />
        <SidebarMenuItem to='/apps/premium-requests' title='Premium Requests management' hasBullet={true} />
        <SidebarMenuItem to='/edit-text' title='Edit Practitioner Text' hasBullet={true} />
        <SidebarMenuItem to='/profile-photos' title='Profile Photos' hasBullet={true} />
        <SidebarMenuItem to='/listing-order' title='Listing Order' hasBullet={true} />
      </SidebarMenuItemWithSub>

      <SidebarMenuItemWithSub
        title='Classes & Bookings'
        icon='/media/icons/duotune/general/gen014.svg'
        fontIcon='bi-calendar-check'
      >
        <SidebarMenuItem to='/apps/classes/1' title='Classes management' hasBullet={true} />
        <SidebarMenuItem to='/apps/bookings/1' title='Bookings management' hasBullet={true} />
        <SidebarMenuItem to='/packs-memberships' title='Packs & Memberships' hasBullet={true} />
        <SidebarMenuItem to='/specials' title='Specials' hasBullet={true} />
      </SidebarMenuItemWithSub>

      <SidebarMenuItemWithSub
        title='Payments'
        icon='/media/icons/duotune/finance/fin002.svg'
        fontIcon='bi-credit-card'
      >
        <SidebarMenuItem to='/apps/transactions' title='Transactions management' hasBullet={true} />
        <SidebarMenuItem to='/apps/booking-fees-management/booking-fees/1' title='Booking Fees management' hasBullet={true} />
      </SidebarMenuItemWithSub>

      <SidebarMenuItemWithSub
        title='App Content'
        icon='/media/icons/duotune/general/gen025.svg'
        fontIcon='bi-grid'
      >
        <SidebarMenuItem to='/categories' title='Categories' hasBullet={true} />
        <SidebarMenuItem to='/faqs' title='FAQ' hasBullet={true} />
        <SidebarMenuItem to='/meditations' title='Guided Meditations' hasBullet={true} />
        <SidebarMenuItem to='/push-notifications' title='Push Notifications' hasBullet={true} />
      </SidebarMenuItemWithSub>

      <SidebarMenuItemWithSub
        title='Reviews & Moderation'
        icon='/media/icons/duotune/general/gen029.svg'
        fontIcon='bi-star'
      >
        <SidebarMenuItem to='/reviews' title='Reviews' hasBullet={true} />
        <SidebarMenuItem to='/flagged-content' title='Flagged Content' hasBullet={true} />
      </SidebarMenuItemWithSub>

      <SidebarMenuItemWithSub
        title='Settings'
        icon='/media/icons/duotune/files/fil001.svg'
        fontIcon='bi-gear'
      >
        <SidebarMenuItem to='/crafted/account/overview' title='Admin Profile' hasBullet={true} />
        <SidebarMenuItem to='/apps/user-management/users' title='Sub Admins' hasBullet={true} />
        <SidebarMenuItem to='settings/terms-and-condition' title='Terms and Condition' hasBullet={true} />
        <SidebarMenuItem to='settings/privacy-policy' title='Privacy Policy' hasBullet={true} />
        <SidebarMenuItem to='/settings/faq' title='FAQ (old form)' hasBullet={true} />
        <SidebarMenuItem to='settings/branding' title='Logo & Sign-In Content' hasBullet={true} />
        <SidebarMenuItem to='/contact' title='Contact Us' hasBullet={true} />
      </SidebarMenuItemWithSub>

      {/* Old Sidebar Menu Items start  */}
      {/* <SidebarMenuItemWithSub
        to='/crafted/pages'
        title='Pages'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen022.svg'
      >
        <SidebarMenuItemWithSub to='/crafted/pages/profile' title='Profile' hasBullet={true}>
          <SidebarMenuItem to='/crafted/pages/profile/overview' title='Overview' hasBullet={true} />
          <SidebarMenuItem to='/crafted/pages/profile/projects' title='Projects' hasBullet={true} />
          <SidebarMenuItem
            to='/crafted/pages/profile/campaigns'
            title='Campaigns'
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/crafted/pages/profile/documents'
            title='Documents'
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/crafted/pages/profile/connections'
            title='Connections'
            hasBullet={true}
          />
        </SidebarMenuItemWithSub>

        <SidebarMenuItemWithSub to='/crafted/pages/wizards' title='Wizards' hasBullet={true}>
          <SidebarMenuItem
            to='/crafted/pages/wizards/horizontal'
            title='Horizontal'
            hasBullet={true}
          />
          <SidebarMenuItem to='/crafted/pages/wizards/vertical' title='Vertical' hasBullet={true} />
        </SidebarMenuItemWithSub>
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to='/crafted/accounts'
        title='Accounts'
        icon='/media/icons/duotune/communication/com006.svg'
        fontIcon='bi-person'
      >
        <SidebarMenuItem to='/crafted/account/overview' title='Overview' hasBullet={true} />
        <SidebarMenuItem to='/crafted/account/settings' title='Settings' hasBullet={true} />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to='/error'
        title='Errors'
        fontIcon='bi-sticky'
        icon='/media/icons/duotune/general/gen040.svg'
      >
        <SidebarMenuItem to='/error/404' title='Error 404' hasBullet={true} />
        <SidebarMenuItem to='/error/500' title='Error 500' hasBullet={true} />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to='/crafted/widgets'
        title='Widgets'
        icon='/media/icons/duotune/general/gen025.svg'
        fontIcon='bi-layers'
      >
        <SidebarMenuItem to='/crafted/widgets/lists' title='Lists' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/statistics' title='Statistics' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/charts' title='Charts' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/mixed' title='Mixed' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/tables' title='Tables' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/feeds' title='Feeds' hasBullet={true} />
      </SidebarMenuItemWithSub>
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Apps</span>
        </div>
      </div>
      

      */}
    </>
  )
}

export {SidebarMenuMain}
